let _wsp = null

export function setWsp (wsp) {
  _wsp = wsp
}

export async function send (data) {
  if (!_wsp || !_wsp.isOpened) {
    throw new Error(`Message doesn't send. WebSocket is not connected. ${JSON.stringify(data)}`)
  }

  const response = await _wsp.sendRequest(data)

  if (response?.error) {
    return Promise.reject(response.error)
  }

  return response
}
